import { render, staticRenderFns } from "./ProposalInsureds.vue?vue&type=template&id=cf820e36"
import script from "./ProposalInsureds.vue?vue&type=script&lang=js"
export * from "./ProposalInsureds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports